import { reactive } from 'vue'
import axios from 'axios'

// 环境能力由服务端决定；浏览器参数和存储不能开启功能。
export const researchSharing = reactive({ loaded: false, enabled: false })
let pending
export function loadResearchSharing() {
  if (researchSharing.loaded) return Promise.resolve(researchSharing.enabled)
  if (pending) return pending
  pending = axios
    .get('/api/features')
    .then((response) => {
      researchSharing.enabled = response.data?.code === 200 && response.data?.data?.researchSharing === true
      return researchSharing.enabled
    })
    .catch(() => {
      researchSharing.enabled = false
      return false
    })
    .finally(() => {
      researchSharing.loaded = true
      pending = undefined
    })
  return pending
}
